import type { useToast } from "primevue/usetoast";
import type { QueryOptions, OperationVariables } from "@apollo/client/core";

/**
 * Generic function which is bound to the grapqhl
 * types to ensure type safety as in @/node_modules/@apollo/client/core/ApolloClient.d.ts
 */
export default async function <
  T = any,
  TVariables extends OperationVariables = OperationVariables
>(
  queryOptions: QueryOptions<TVariables, T>,
  errorMessage: string = "Es ist ein Fehler aufgetreten"
) {
  const nuxtApp = useNuxtApp();
  const getToast: typeof useToast = () =>
    nuxtApp.vueApp.config.globalProperties.$toast;
  const toastService = getToast();

  const { resolveClient } = useApolloClient();
  const apolloClient = resolveClient("webSocketClient");
  try {
    const res = await apolloClient.subscribe<T>({
      query: queryOptions.query,
      variables: queryOptions.variables,
    });

    return res;
  } catch (error) {
    setTimeout(() => {
      toastService.add({
        severity: "error",
        summary: errorMessage,
        life: 3000,
      });
    }, 3000);
  }
}
